/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AutoWithdrawalCurrencyInfo } from './auto-withdrawal-currency-info';


export interface SearchUserAutoWithdrawalSettingsResponseItem { 
    accountId: string;
    accountName: string;
    rewardType: string;
    currencies: Array<AutoWithdrawalCurrencyInfo>;
}

